"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _auth = require("@/utils/auth");
var _product = require("@/api/product");
var _productCdkey = require("@/api/productCdkey");
var _validate = require("@/utils/validate");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2023 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
// import exportExcel from '@/utils/newToExcel.js';
var _default2 = exports.default = {
  name: 'addCarMy',
  props: {
    virtualList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    libraryId: {
      type: Number,
      default: function _default() {
        return 0;
      }
    }
  },
  data: function data() {
    return {
      cdkeyShow: false,
      header: {},
      //请求头部信息
      carMyValidateForm: {
        carMyList: [{
          cardNumber: '',
          secretNum: ''
        }, {
          cardNumber: '',
          secretNum: ''
        }]
      },
      btnloading: false
    };
  },
  mounted: function mounted() {},
  methods: {
    //取消
    handleClose: function handleClose() {
      this.cdkeyShow = false;
      this.carMyValidateForm = {
        carMyList: [{
          cardNumber: '',
          secretNum: ''
        }, {
          cardNumber: '',
          secretNum: ''
        }]
      };
    },
    //添加行
    handleAddCard: function handleAddCard() {
      this.carMyValidateForm.carMyList.push({
        cardNumber: '',
        secretNum: '',
        key: Date.now()
      });
    },
    removeCard: function removeCard(item) {
      var index = this.carMyValidateForm.carMyList.indexOf(item);
      if (index !== -1) {
        this.carMyValidateForm.carMyList.splice(index, 1);
      }
    },
    //保存
    submitForm: (0, _validate.Debounce)(function (formName) {
      var _this = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this.btnloading = true;
          (0, _productCdkey.cardSecretSaveApi)({
            csList: _this.carMyValidateForm.carMyList,
            libraryId: _this.libraryId
          }).then(function (res) {
            _this.$message.success('新增成功');
            _this.btnloading = false;
            _this.$emit('handlerSubSuccess', _this.carMyValidateForm.carMyList);
            _this.handleClose();
          }).catch(function (res) {
            _this.btnloading = false;
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    })
  }
};